import React, { Component } from 'react';
import {
    Box,
    IconButton,
    MenuItem,
    TextField,
    Typography
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import i18n from 'i18next';

class SingleFile extends Component {
    handleInput = () => {};
    onOpenPopover = () => {};

    constructor(props) {
        super(props);
        this.handleInput = props.handleInput;
        this.onOpenPopover = props.onOpenPopover;
    }

    render() {
        const { file, inputFileType, fieldFileType, fileTypes } = this.props;

        return (
            <Box
                key={file.name}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    margin: 1,
                    padding: 1,
                    borderRadius: 1,
                    boxSizing: 'border-box'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        bgcolor: 'background.paper',
                        margin: 1
                    }}
                >
                    <img
                        width="70px"
                        height="70px"
                        style={{ borderRadius: '6px' }}
                        src={file.url}
                        alt="upload"
                    />

                    <Typography
                        marginX={1}
                        variant="caption"
                        sx={{
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {file.name}
                    </Typography>

                    <IconButton
                        onClick={(event) => this.onOpenPopover(event, file.id)}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Box>

                {inputFileType && (
                    <TextField
                        fullWidth
                        select
                        margin="dense"
                        variant="outlined"
                        label="File Type"
                        value={file[fieldFileType]}
                        onChange={(event) => this.handleInput(event, file.id)}
                    >
                        {fileTypes.map((option) => (
                            <MenuItem key={option} value={option}>
                                {i18n.t(`enums.${option}`)}
                            </MenuItem>
                        ))}
                    </TextField>
                )}
            </Box>
        );
    }
}

export default SingleFile;
